import React, { useState, useContext, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import './CompanyProfileOptions.css';
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import URLstateContext from "../../../provider/CommonContext";


function CompanyProfileOptions(props) {
    let getCompOption = props.compOption;
    const { BaseURL } = useContext(URLstateContext);
    const { getCompName } = useParams();
    const [infoOption, setInfoOption] = useState('');
    let navigate = useNavigate();

    useEffect(() => {
        if (infoOption === "Overview") {
            navigate("/market/stocks");
        }
        if (infoOption === "Get Quotes") {
            navigate("/CompanyProfile/Get-Quotes");
        }
        if (infoOption === "Company Background") {
            navigate("/CompanyProfile/Company-Background/" + getCompName);
        }
        if (infoOption === "Balance Sheet") {
            navigate("/CompanyProfile/Balance-Sheet/" + getCompName);
        }
        if (infoOption === "Board of Directors") {
            navigate("/CompanyProfile/Board-of-Directors/" + getCompName);
        }
        if (infoOption === "Profit & Loss Accounts") {
            navigate("/CompanyProfile/Profit-Loss-Accounts/" + getCompName);
        }
        if (infoOption === "Quarterly Results") {
            navigate("/CompanyProfile/Quarterly-Results/" + getCompName);
        }
        if (infoOption === "Key Financial Ratios") {
            navigate("/CompanyProfile/Key-Financial-Ratios/" + getCompName);
        }
        if (infoOption === "Share Price") {
            navigate("/CompanyProfile/Share-Price/" + getCompName);
        }
        if (infoOption === "Share Holding Pattern") {
            navigate("/CompanyProfile/Share-Holding-Pattern/" + getCompName);
        }
        if (infoOption === "Intraday / EOD charts") {
            navigate("/CompanyProfile/Intraday-charts/" + getCompName);
        }
        if (infoOption === "Cash Flow") {
            navigate("/CompanyProfile/Cash-Flow/" + getCompName);
        }
        if (infoOption === "Directors Reports") {
            navigate("/CompanyProfile/Directors-Reports/" + getCompName);
        }
        if (infoOption === "Score Board") {
            navigate("/CompanyProfile/Score-Board/" + getCompName);
        }
        if (infoOption === "MF Holdings") {
            navigate("/CompanyProfile/MF-Holdings/" + getCompName);
        }
        if (infoOption === "Name Change") {
            navigate("/CompanyProfile/Name-Change/" + getCompName);
        }
        if (infoOption === "Company News") {
            navigate("/CompanyProfile/Company-News/" + getCompName);
        }
        if (infoOption === "Peer Comparison") {
            navigate("/CompanyProfile/Peer-Comparison/" + getCompName);
        }
        if (infoOption === "Bonus History") {
            navigate("/CompanyProfile/Bonus-History/" + getCompName);
        }
        if (infoOption === "Dividend") {
            navigate("/CompanyProfile/Dividend/" + getCompName);
        }
        if (infoOption === "Rights") {
            navigate("/CompanyProfile/Rights/" + getCompName);
        }
        if (infoOption === "Announcements") {
            navigate("/CompanyProfile/Announcements/" + getCompName);
        }
        if (infoOption === "Board Meeting") {
            navigate("/CompanyProfile/Board-Meeting/" + getCompName);
        }
        if (infoOption === "Book Closure") {
            navigate("/CompanyProfile/Book-Closure/" + getCompName);
        }
        if (infoOption === "Prev Quarter Comp") {
            navigate("/CompanyProfile/Prev-Quarter-Comp/" + getCompName);
        }
        if (infoOption === "Company Snapshot") {
            window.open("/stocks/" + getCompName.toLowerCase(), '_blank');
        }
    }, [infoOption]);


    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='market-loser-sc'>
                            <div className='market-inner'>
                                <div className='market-select'>
                                    <select value={getCompOption} onChange={(event) => { setInfoOption(event.target.value) }}>
                                        <option value={"Overview"}>Overview</option>
                                        <option value={"Get Quotes"}>Get Quotes</option>
                                        <option value={"Company Background"}>Company Background</option>
                                        <option value={"Board of Directors"}>Board of Directors</option>
                                        <option value={"Balance Sheet"}>Balance Sheet</option>
                                        <option value={"Profit & Loss Accounts"}>Profit & Loss Accounts</option>
                                        <option value={"Quarterly Results"}>Quarterly Results</option>
                                        <option value={"Key Financial Ratios"}>Key Financial Ratios</option>
                                        <option value={"Share Price"}>Share Price</option>
                                        <option value={"Intraday / EOD charts"}>Intraday / EOD charts</option>
                                        <option value={"Cash Flow"}>Cash Flow</option>
                                        <option value={"Company Snapshot"}>Company Snapshot</option>
                                        <option value={"Share Holding Pattern"}>Share Holding Pattern</option>
                                        <option value={"Directors Reports"}>Directors Reports</option>
                                        <option value={"MF Holdings"}>MF Holdings</option>
                                        <option value={"Name Change"}>Name Change</option>
                                        <option value={"Company News"}>Company News</option>
                                        <option value={"Peer Comparison"}>Peer Comparison</option>
                                        <option value={"Bonus History"}>Bonus History</option>
                                        <option value={"Prev Quarter Comp"}>Prev Quarter Comp</option>
                                        <option value={"Dividend"}>Dividend</option>
                                        <option value={"Rights"}>Rights</option>
                                        <option value={"Announcements"}>Announcements</option>
                                        <option value={"Board Meeting"}>Board Meeting</option>
                                        <option value={"Book Closure"}>Book Closure</option>
                                    </select>
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default CompanyProfileOptions;